import { ScaleElement } from '@scale/base-element';
import { CartAPI } from '@scale/cart-api';

class ScaleCartCurlizzOffer extends ScaleElement {
  async upgrade(event) {
    const button = event?.currentTarget;
    const targetQuantity = Number(button?.dataset.targetQuantity);
    const key = this.dataset.key;

    if (!button || !key || !Number.isInteger(targetQuantity) || targetQuantity < 1) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    this.classList.add('cart-offer--loading');

    try {
      const sectionId = this.dataset.sectionId;
      await CartAPI.change(key, targetQuantity, { sections: sectionId ? [sectionId] : [] });
      this.announce(`Quantité Curlizz : ${targetQuantity}`, 'polite');
    } catch (error) {
      if (error?.name !== 'AbortError') {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        this.classList.remove('cart-offer--loading');
      }
    }
  }
}

if (!customElements.get('scale-cart-curlizz-offer')) {
  customElements.define('scale-cart-curlizz-offer', ScaleCartCurlizzOffer);
}
